module.exports = __webpack_public_path__ + "img/5.a95ec55c.png";